/**
 * API Configuration
 */

export const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://dineai.ai/api';
export const FRONTEND_URL = import.meta.env.VITE_FRONTEND_URL || 'https://dineai.ai';

/**
 * Get the full API URL for an endpoint
 */
export const getApiUrl = (endpoint: string): string => {
  // Remove leading slash from endpoint if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL}/${cleanEndpoint}`;
};

/**
 * Get the full frontend URL for a path
 */
export const getFrontendUrl = (path: string): string => {
  // Remove leading slash from path if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${FRONTEND_URL}/${cleanPath}`;
};